import axios from "axios";

export const empApi = axios.create({
  baseURL: "http://apisvc.metro.net/fis"
});

export const ccatsApi = axios.create({
  //baseURL: "http://ccatsdev2.metro.net/api/"
   baseURL: "http://ccatsstage.metro.net/api/" // PRODUCTION API
});

export const localApi = axios.create({
  baseURL: "http://localhost:61341/"
});
